import { warnings, WarningTypes, objectTypes } from '../types'
import { Props } from './types'

const getWarningTextForProject = (warning: WarningTypes) => {
  const result = {
    title: 'The project is not available for publishing.',
    subtitle: ''
  }

  switch (warning) {
    case warnings.missingVideo:
      result.subtitle = '<span>Video file</span> is missing.'
      break

    case warnings.videoNotProcessed:
      result.subtitle = 'The video file is <span>not processed</span>.'
      break

    case warnings.missingImages:
      result.subtitle = 'Images are missing.'
      break

    case warnings.missingImageWithPortraitCrop:
      result.subtitle = 'An image with <span>portrait crop</span> is missing.'
      break

    default: break
  }

  return result
}

const getWarningTextForPerson = (warning: WarningTypes) => {
  const result = {
    title: '',
    subtitle: ''
  }

  switch (warning) {
    case warnings.missingImages:
      result.title = 'Person\'s images problem'
      result.subtitle = 'Images are missing.'
      break

    case warnings.missingImageWithPortraitCrop:
      result.title = 'Person\'s images problem'
      result.subtitle = 'An image with <span>portrait crop</span> is missing.'
      break

    default: break
  }

  return result
}

const getWarningTextForBrand = (warning: WarningTypes) => {
  const result = {
    title: '',
    subtitle: ''
  }

  switch (warning) {
    case warnings.missingImages:
      result.title = 'Brand\'s images problem'
      result.subtitle = 'Images are missing.'
      break

    case warnings.missingImageWithPortraitCrop:
      result.title = 'Brand\'s images problem'
      result.subtitle = 'An image with <span>portrait crop</span> is missing.'
      break

    default: break
  }

  return result
}

const getWarningTextForProduct = (warning: WarningTypes) => {
  const result = {
    title: '',
    subtitle: ''
  }

  switch (warning) {
    case warnings.missingImages:
      result.title = 'Product\'s images problem'
      result.subtitle = 'Images are missing.'
      break

    case warnings.missingImageWithPortraitCrop:
      result.title = 'Product\'s images problem'
      result.subtitle = 'An image with <span>portrait crop</span> is missing.'
      break

    case warnings.missingGeneralPortrait:
      result.title = 'Product\'s images problem'
      result.subtitle = 'A <span>portrait crop</span> image for <span>general use</span> is missing.'
      break

    case warnings.missingGeneralSquare:
      result.title = 'Product\'s images problem'
      result.subtitle = 'A <span>square crop</span> image for <span>general use</span> is missing.'
      break

    default: break
  }

  return result
}

const getWarningTextForAgreement = (warning: WarningTypes) => {
  const result = {
    title: '',
    subtitle: ''
  }

  switch (warning) {
    case warnings.noRemainingBudget:
      result.title = 'No remaining budget.'
      break
    case warnings.lowBudget:
      result.title = 'Remaining budget for this agreement is low.'
      break
    case warnings.periodExpired:
      result.title = 'Agreement has expired.'
      break
    case warnings.periodAboutToExpire:
      result.title = 'Agreement is about to expire.'
      break
    default: break
  }

  return result
}

export const getWarningText = ({ warning, objectType }: Props) => {
  switch (objectType) {
    case objectTypes.project: return getWarningTextForProject(warning)
    case objectTypes.person: return getWarningTextForPerson(warning)
    case objectTypes.brand: return getWarningTextForBrand(warning)
    case objectTypes.product: return getWarningTextForProduct(warning)
    case objectTypes.agreement: return getWarningTextForAgreement(warning)
  }
}
